var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophyStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy-star 1",
    clipPath: "url(#clip0_521_655294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.00195 8.46191H10.3309V11.4854H9.00195V8.46191Z",
    fill: "url(#paint0_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.16553 12.7787C8.16553 11.949 8.83701 11.2705 9.6667 11.2705C10.4964 11.2705 11.1679 11.949 11.1679 12.7787H8.16553Z",
    fill: "url(#paint1_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.55713 12.7793H11.7759C12.1626 12.7793 12.479 13.0957 12.479 13.4824V14.7129H6.854V13.4824C6.854 13.0957 7.17041 12.7793 7.55713 12.7793Z",
    fill: "url(#paint2_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.41455 14.7129H12.9185C13.4528 14.7129 13.8853 15.1453 13.8853 15.6797C13.8853 16.2141 13.4528 16.6465 12.9185 16.6465H6.41455C5.88018 16.6465 5.44775 16.2141 5.44775 15.6797C5.44775 15.1453 5.88018 14.7129 6.41455 14.7129Z",
    fill: "url(#paint3_linear_521_655294)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.0904 12.4764C11.0025 12.4764 10.9252 12.4096 10.9146 12.3182C10.9041 12.2198 10.9744 12.1354 11.0728 12.1249C11.0939 12.1213 12.3982 11.9737 13.6427 10.9823C15.2916 9.66744 16.0967 7.45611 15.9631 4.59439C15.9595 4.49595 16.0334 4.41509 16.1318 4.41158C16.2267 4.40455 16.3111 4.48189 16.3146 4.58033C16.3884 6.24322 16.167 7.69166 15.6502 8.88697C15.2318 9.85025 14.6271 10.6518 13.8467 11.2706C12.5177 12.3217 11.1642 12.4729 11.108 12.4764C11.1045 12.4764 11.0974 12.4764 11.0904 12.4764Z",
    fill: "url(#paint4_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.4961 6.63328C16.8773 7.14656 16.002 7.10789 16.002 7.10789C16.002 7.10789 16.1285 6.23953 16.7473 5.72625C17.366 5.21297 18.2414 5.25164 18.2414 5.25164C18.2414 5.25164 18.1148 6.12 17.4961 6.63328Z",
    fill: "url(#paint5_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.6464 5.57891C16.1069 6.23633 15.998 7.1082 15.998 7.1082C15.998 7.1082 15.1437 6.91133 14.6831 6.25391C14.2226 5.59648 14.3316 4.72461 14.3316 4.72461C14.3316 4.72461 15.1859 4.92148 15.6464 5.57891Z",
    fill: "url(#paint6_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.1791 7.48086C15.5834 8.17695 15.4006 9.03477 15.4006 9.03477C15.4006 9.03477 14.5639 8.76406 14.1631 8.07148C13.7588 7.37539 13.9416 6.51758 13.9416 6.51758C13.9416 6.51758 14.7783 6.78477 15.1791 7.48086Z",
    fill: "url(#paint7_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M14.4054 9.2668C14.5671 10.0543 14.1207 10.8102 14.1207 10.8102C14.1207 10.8102 13.414 10.2898 13.2558 9.50234C13.0976 8.71484 13.5406 7.95898 13.5406 7.95898C13.5406 7.95898 14.2437 8.4793 14.4054 9.2668Z",
    fill: "url(#paint8_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M13.1715 10.684C13.0063 11.4715 12.2961 11.9883 12.2961 11.9883C12.2961 11.9883 11.8531 11.2289 12.0184 10.4449C12.1836 9.66094 12.8938 9.14062 12.8938 9.14062C12.8938 9.14062 13.3367 9.89648 13.1715 10.684Z",
    fill: "url(#paint9_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M16.9298 8.69708C16.2688 9.15059 15.397 9.03458 15.397 9.03458C15.397 9.03458 15.6009 8.18028 16.2653 7.72677C16.9298 7.27325 17.7981 7.38927 17.7981 7.38927C17.7981 7.38927 17.5942 8.24356 16.9298 8.69708Z",
    fill: "url(#paint10_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M15.6925 10.8241C14.9437 11.1159 14.1245 10.8065 14.1245 10.8065C14.1245 10.8065 14.5183 10.0225 15.2671 9.73075C16.0159 9.43895 16.8351 9.74833 16.8351 9.74833C16.8351 9.74833 16.4413 10.5323 15.6925 10.8241Z",
    fill: "url(#paint11_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M13.7343 12.6074C12.9292 12.5863 12.2964 11.9816 12.2964 11.9816C12.2964 11.9816 12.9644 11.4121 13.7659 11.4332C14.5675 11.4543 15.2038 12.059 15.2038 12.059C15.2038 12.059 14.5358 12.6285 13.7343 12.6074Z",
    fill: "url(#paint12_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M16.7436 4.1625C16.7436 4.96758 16.1564 5.61797 16.1564 5.61797C16.1564 5.61797 15.5693 4.96758 15.5693 4.1625C15.5693 3.35742 16.1529 2.70703 16.1529 2.70703C16.1529 2.70703 16.7436 3.35742 16.7436 4.1625Z",
    fill: "url(#paint13_linear_521_655294)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M8.2425 12.4764C8.33039 12.4764 8.40773 12.4096 8.41828 12.3182C8.42883 12.2198 8.35851 12.1354 8.26008 12.1249C8.23898 12.1213 6.93469 11.9737 5.69015 10.9823C4.04133 9.66744 3.23625 7.45611 3.36984 4.59439C3.37336 4.49595 3.29953 4.41509 3.20109 4.41158C3.10617 4.40455 3.02179 4.48189 3.01828 4.58033C2.94094 6.24322 3.16594 7.69166 3.68273 8.88697C4.10109 9.85025 4.70578 10.6518 5.48625 11.2706C6.81515 12.3217 8.16867 12.4729 8.22492 12.4764H8.2425Z",
    fill: "url(#paint14_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M1.83711 6.63328C2.45586 7.14656 3.33477 7.10789 3.33477 7.10789C3.33477 7.10789 3.2082 6.23953 2.58945 5.72625C1.9707 5.21297 1.0918 5.25164 1.0918 5.25164C1.0918 5.25164 1.21836 6.12 1.83711 6.63328Z",
    fill: "url(#paint15_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M3.68605 5.57891C3.2255 6.23633 3.33449 7.1082 3.33449 7.1082C3.33449 7.1082 4.18879 6.91133 4.64933 6.25391C5.10988 5.59648 5.0009 4.72461 5.0009 4.72461C5.0009 4.72461 4.1466 4.92148 3.68605 5.57891Z",
    fill: "url(#paint16_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M4.15404 7.48086C3.75326 8.17695 3.93256 9.03477 3.93256 9.03477C3.93256 9.03477 4.76928 8.76406 5.17006 8.07148C5.57084 7.37891 5.39154 6.51758 5.39154 6.51758C5.39154 6.51758 4.55483 6.78477 4.15404 7.48086Z",
    fill: "url(#paint17_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M4.92738 9.2668C4.76567 10.0543 5.21215 10.8102 5.21215 10.8102C5.21215 10.8102 5.91879 10.2898 6.08051 9.50234C6.24223 8.71484 5.79574 7.95898 5.79574 7.95898C5.79574 7.95898 5.0891 8.4793 4.92738 9.2668Z",
    fill: "url(#paint18_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M6.16143 10.684C6.32666 11.4715 7.03682 11.9883 7.03682 11.9883C7.03682 11.9883 7.47979 11.2289 7.31456 10.4449C7.14932 9.66094 6.43916 9.14062 6.43916 9.14062C6.43916 9.14062 5.9962 9.89648 6.16143 10.684Z",
    fill: "url(#paint19_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M2.40303 8.69708C3.06396 9.15059 3.93584 9.03458 3.93584 9.03458C3.93584 9.03458 3.73193 8.18028 3.06748 7.72677C2.40303 7.27325 1.53467 7.38927 1.53467 7.38927C1.53467 7.38927 1.73857 8.24356 2.40303 8.69708Z",
    fill: "url(#paint20_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M3.64053 10.8241C4.38936 11.1159 5.2085 10.8065 5.2085 10.8065C5.2085 10.8065 4.81475 10.0225 4.06943 9.73075C3.32061 9.43895 2.50146 9.74833 2.50146 9.74833C2.50146 9.74833 2.8917 10.5323 3.64053 10.8241Z",
    fill: "url(#paint21_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M5.59893 12.6074C6.404 12.5863 7.03682 11.9816 7.03682 11.9816C7.03682 11.9816 6.36885 11.4121 5.56728 11.4332C4.76572 11.4543 4.12939 12.059 4.12939 12.059C4.12939 12.059 4.79736 12.6285 5.59893 12.6074Z",
    fill: "url(#paint22_linear_521_655294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M2.58936 4.1625C2.58936 4.96758 3.17646 5.61797 3.17646 5.61797C3.17646 5.61797 3.76357 4.96758 3.76357 4.1625C3.76357 3.35742 3.17646 2.70703 3.17646 2.70703C3.17646 2.70703 2.58936 3.35742 2.58936 4.1625Z",
    fill: "url(#paint23_linear_521_655294)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M10.5383 1.88042L11.3399 3.40972L13.0449 3.698C13.8289 3.83159 14.1418 4.79136 13.5863 5.35737L12.377 6.59487L12.6266 8.30347C12.7426 9.09097 11.927 9.68159 11.2133 9.33003L9.66642 8.56714L8.11955 9.33355C7.40587 9.68511 6.59025 9.09448 6.70626 8.30698L6.95587 6.59839L5.7465 5.36089C5.19103 4.79136 5.50392 3.83511 6.28791 3.70151L7.99298 3.41323L8.79455 1.88394C9.16369 1.1773 10.1692 1.1773 10.5383 1.88042Z",
    fill: "url(#paint24_linear_521_655294)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_521_655294",
    x1: 9.66658,
    y1: 11.4845,
    x2: 9.66658,
    y2: 8.46174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD34F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_521_655294",
    x1: 9.6667,
    y1: 11.2693,
    x2: 9.6667,
    y2: 12.7789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD34F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_521_655294",
    x1: 9.6665,
    y1: 14.7131,
    x2: 9.6665,
    y2: 12.7795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D5969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_521_655294",
    x1: 9.6665,
    y1: 16.6467,
    x2: 9.6665,
    y2: 14.7131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_521_655294",
    x1: 13.6231,
    y1: 4.40905,
    x2: 13.6231,
    y2: 12.4766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_521_655294",
    x1: 17.114,
    y1: 7.11697,
    x2: 17.1145,
    y2: 5.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_521_655294",
    x1: 15.1636,
    y1: 7.12416,
    x2: 15.164,
    y2: 4.74089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_521_655294",
    x1: 14.616,
    y1: 9.01154,
    x2: 14.7086,
    y2: 6.55252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_521_655294",
    x1: 13.8306,
    y1: 10.8018,
    x2: 13.8299,
    y2: 7.94974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_521_655294",
    x1: 12.604,
    y1: 11.9784,
    x2: 12.6031,
    y2: 9.12968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_521_655294",
    x1: 16.5725,
    y1: 9.07767,
    x2: 16.6382,
    y2: 7.33393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_521_655294",
    x1: 15.4638,
    y1: 10.9375,
    x2: 15.4643,
    y2: 9.59151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_521_655294",
    x1: 13.7552,
    y1: 12.6267,
    x2: 13.7549,
    y2: 11.4499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_521_655294",
    x1: 16.1547,
    y1: 5.61674,
    x2: 16.1547,
    y2: 2.7065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_521_655294",
    x1: 5.71016,
    y1: 4.40905,
    x2: 5.71016,
    y2: 12.4766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_521_655294",
    x1: 2.21932,
    y1: 7.11674,
    x2: 2.2188,
    y2: 5.26076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_521_655294",
    x1: 4.16854,
    y1: 7.12399,
    x2: 4.16807,
    y2: 4.74075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_521_655294",
    x1: 4.71719,
    y1: 9.01167,
    x2: 4.62462,
    y2: 6.55267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_521_655294",
    x1: 5.50269,
    y1: 10.802,
    x2: 5.5034,
    y2: 7.94996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_521_655294",
    x1: 6.72938,
    y1: 11.9787,
    x2: 6.73033,
    y2: 9.12997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_521_655294",
    x1: 2.76028,
    y1: 9.07785,
    x2: 2.69458,
    y2: 7.33411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_521_655294",
    x1: 3.86926,
    y1: 10.9373,
    x2: 3.86879,
    y2: 9.5913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_521_655294",
    x1: 5.57823,
    y1: 12.6269,
    x2: 5.5786,
    y2: 11.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_521_655294",
    x1: 3.17822,
    y1: 5.61674,
    x2: 3.17822,
    y2: 2.7065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_521_655294",
    x1: 9.66632,
    y1: 9.43842,
    x2: 9.66632,
    y2: 1.3528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC100"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_521_655294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyStar);
export default __webpack_public_path__ + "static/media/trophy-star.85843f930cab552fe9ea532f659c7b2b.svg";
export { ForwardRef as ReactComponent };